import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/creative-commons-sampling': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M247.6 8c141.8 0 248.4 110.1 248.4 248 0 147.1-118.5 248-248.4 248-134 0-247.6-109.5-247.6-248 0-132.9 104.7-248 247.6-248zM248.4 52.7c-118.2 0-203.7 97.9-203.7 203.3 0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8 0.1-113.8-90.2-203.3-202.8-203.3zM252 105.9c2.8-0.3 11.5 1 11.5 11.5l6.6 107.2 4.9-59.3c0-6 4.7-10.6 10.6-10.6 5.9 0 10.6 4.7 10.6 10.6 0 2.5-0.5-5.7 5.7 81.5l5.8-64.2c0.3-2.9 2.9-9.3 10.2-9.3 3.8 0 9.9 2.3 10.6 8.9l11.5 96.5 5.3-12.8c1.8-4.4 5.2-6.6 10.2-6.6h58v21.3h-50.9l-18.2 44.3c-3.9 9.9-19.5 9.1-20.8-3.1l-4-31.9-7.5 92.6c-0.3 3-3 9.3-10.2 9.3-3 0-9.8-2.1-10.6-9.3 0-1.9 0.6 5.8-6.2-77.9l-5.3 72.2c-1.1 4.8-4.8 9.3-10.6 9.3-2.9 0-9.8-2-10.6-9.3 0-1.9 0.5 6.7-5.8-87.7l-5.8 94.8c0 6.3-3.6 12.4-10.6 12.4-5.2 0-10.6-4.1-10.6-12l-5.8-87.7c-5.8 92.5-5.3 84-5.3 85.9-1.1 4.8-4.8 9.3-10.6 9.3-3 0-9.8-2.1-10.6-9.3 0-0.7-0.4-1.1-0.4-2.6l-6.2-88.6-4.9 56.7c-0.7 6.5-6.7 9.3-10.6 9.3-5.8 0-9.6-4.1-10.6-8.9l-11.1-76.4c-2 4-3.5 8.4-11.1 8.4h-51.4v-21.3h44.8l13.7-27.9c4.4-9.9 18.2-7.2 19.9 2.7l3.1 20.4 8.4-97.9c0-6 4.8-10.6 10.6-10.6 0.5 0 10.6-0.2 10.6 12.4l4.9 69.1 6.6-92.6c0-10.1 9.5-10.6 10.2-10.6 0.6 0 10.6 0.7 10.6 10.6l5.3 80.6 6.2-97.9c0.1-1.1-0.6-10.3 9.9-11.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/creative-commons-sampling.js
// module id = 773
// module chunks = 0